import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'

const Project2Card = () => {
    return (
        <Container>
            <Row>
                <Col lg={10} className='mx-auto'>
                    <p className='lead'>
                        Amid the early hype around blockchain as a way to secure digital, and potentially physical,
                        assets, I built SafeHouse Digital to test the idea directly: a blockchain-backed system for
                        storing and verifying real estate ownership documents such as leases and deeds.
                    </p>

                    <h3 className='text-uppercase mt-4 fs-6 fw-bold'>What I Built</h3>
                    <ul>
                        <li>A blockchain network and smart contracts to store, timestamp, and verify ownership documents.</li>
                        <li>A decentralized application (DApp) interface for uploading documents and viewing verification status.</li>
                        <li>An identity verification step that cryptographically linked a user's identity to their uploaded documents before granting write access.</li>
                    </ul>

                    <h3 className='text-uppercase mt-4 fs-6 fw-bold'>Outcome</h3>
                    <p>
                        The system produced a working, end-to-end flow: upload a document, verify identity, and
                        receive a digitally verified, tamper-evident proof of ownership. It served as a useful proof
                        of concept for where blockchain adds real value in property transactions, and where
                        traditional record-keeping is still simpler.
                    </p>

                    <p className='text-muted mb-0'><i>Completed November 2022</i></p>
                </Col>
            </Row>
        </Container>
    )
}

export default Project2Card;
